import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7e40a582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-paper-info" }
const _hoisted_2 = {
  class: "m-question-wrap",
  ref: "swipWrap"
}
const _hoisted_3 = ["initial-swipe"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_bar = _resolveComponent("action-bar")!
  const _component_que_analysis = _resolveComponent("que-analysis")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showActionBar)
      ? (_openBlock(), _createBlock(_component_action_bar, {
          key: 0,
          class: "m-action-bar",
          onGoBack: $setup.goBack,
          needShare: false,
          actionBarInfo: $setup.actionBarInfo,
          backIcon: require('../../../../assets/images/aio/aio_go_back_x.png')
        }, null, 8, ["onGoBack", "actionBarInfo", "backIcon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "m-analysis-wrap",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.preventDefaultEvent && $setup.preventDefaultEvent(...args)), ["prevent"])),
      style: _normalizeStyle(`padding-top:${$setup.actionBarHeight}px`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionList, (question, index) => {
            return (_openBlock(), _createElementBlock("div", {
              ref_for: true,
              ref: "swipeBoxInner",
              "initial-swipe": $setup.currentIndex,
              key: index
            }, [
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_que_analysis, {
                  questionIndex: index,
                  currentIndex: $setup.currentIndex,
                  questionData: {
                list: question,
                total: $setup.questionList.length,
                isRight: false
              },
                  submitQestionMap: $setup.submitQestionMap
                }, null, 8, ["questionIndex", "currentIndex", "questionData", "submitQestionMap"])
              ], 512), [
                [_vShow, index === $setup.currentIndex]
              ])
            ], 8, _hoisted_3))
          }), 128))
        ], 512)
      ])
    ], 4)
  ], 64))
}